// Language registry. Adding a new language = add an entry here + drop a JSON
// file at /app/frontend/src/i18n/locales/<code>.json — no code changes needed.
// `code` follows BCP 47.

export const LANGUAGES = [
    { code: "en",    name: "English",            flag: "🇬🇧", rtl: false },
    { code: "es",    name: "Español",            flag: "🇪🇸", rtl: false },
    { code: "fr",    name: "Français",           flag: "🇫🇷", rtl: false },
    { code: "de",    name: "Deutsch",            flag: "🇩🇪", rtl: false },
    { code: "it",    name: "Italiano",           flag: "🇮🇹", rtl: false },
    { code: "pt",    name: "Português",          flag: "🇵🇹", rtl: false },
    { code: "nl",    name: "Nederlands",         flag: "🇳🇱", rtl: false },
    { code: "pl",    name: "Polski",             flag: "🇵🇱", rtl: false },
    { code: "ro",    name: "Română",             flag: "🇷🇴", rtl: false },
    { code: "sv",    name: "Svenska",            flag: "🇸🇪", rtl: false },
    { code: "no",    name: "Norsk",              flag: "🇳🇴", rtl: false },
    { code: "da",    name: "Dansk",              flag: "🇩🇰", rtl: false },
    { code: "fi",    name: "Suomi",              flag: "🇫🇮", rtl: false },
    { code: "cs",    name: "Čeština",            flag: "🇨🇿", rtl: false },
    { code: "hu",    name: "Magyar",             flag: "🇭🇺", rtl: false },
    { code: "el",    name: "Ελληνικά",           flag: "🇬🇷", rtl: false },
    { code: "tr",    name: "Türkçe",             flag: "🇹🇷", rtl: false },
    { code: "ru",    name: "Русский",            flag: "🇷🇺", rtl: false },
    { code: "uk",    name: "Українська",         flag: "🇺🇦", rtl: false },
    { code: "hi",    name: "हिन्दी",                flag: "🇮🇳", rtl: false },
    { code: "bn",    name: "বাংলা",                flag: "🇧🇩", rtl: false },
    { code: "ja",    name: "日本語",              flag: "🇯🇵", rtl: false },
    { code: "ko",    name: "한국어",              flag: "🇰🇷", rtl: false },
    { code: "zh-CN", name: "简体中文",            flag: "🇨🇳", rtl: false },
    { code: "zh-TW", name: "繁體中文",            flag: "🇹🇼", rtl: false },
    { code: "ar",    name: "العربية",             flag: "🇸🇦", rtl: true  },
    { code: "he",    name: "עברית",              flag: "🇮🇱", rtl: true  },
    { code: "id",    name: "Bahasa Indonesia",   flag: "🇮🇩", rtl: false },
    { code: "ms",    name: "Bahasa Melayu",      flag: "🇲🇾", rtl: false },
    { code: "vi",    name: "Tiếng Việt",         flag: "🇻🇳", rtl: false },
    { code: "th",    name: "ไทย",                flag: "🇹🇭", rtl: false },
];

// Fully-translated languages for MVP. Other entries still appear in selectors,
// but i18next falls back to English keys until their JSON file is added.
export const TRANSLATED_LANGUAGES = new Set(["en", "es"]);

export const findLanguage = (code) =>
    LANGUAGES.find(l => l.code === code) || LANGUAGES.find(l => code?.startsWith(l.code.split("-")[0])) || LANGUAGES[0];
